export default "__VITE_ASSET__d8db3ce1__"